import { render, staticRenderFns } from "./Unspsc.vue?vue&type=template&id=400b8ec6"
import script from "./Unspsc.vue?vue&type=script&lang=js"
export * from "./Unspsc.vue?vue&type=script&lang=js"
import style0 from "./Unspsc.vue?vue&type=style&index=0&id=400b8ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports